import { ChangeEvent } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  HiddenFieldCategory,
  TemplateHiddenField,
  TemplateHiddenFields,
} from 'types/DataExtraction';

export const useHidingDefaultFields = (category: HiddenFieldCategory) => {
  const formContext = useFormContext();
  if (formContext === null) {
    throw new Error(
      'useHidingDefaultFields called outside of a React hook form context'
    );
  }

  const { setValue, watch } = formContext;
  const hiddenFields = (watch('hidden_fields') as TemplateHiddenFields) || [];

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { checked, value } = e.target;

    const setCheckedFields = (fields: TemplateHiddenFields) =>
      !checked
        ? [...fields, { category: category, name: value }]
        : fields?.filter((f) => f.name !== value);

    setValue('hidden_fields', setCheckedFields(hiddenFields));
  };

  const isChecked = (field: string) => {
    return !hiddenFields.some((f: TemplateHiddenField) => f.name === field);
  };

  return { handleChange, isChecked };
};
